<template>
  <PaOverlayModal
   :isOpen="isModalOpen"
   :appendClass="['pa-overlay-modal-bottom-transition', 'pa-character-detail-modal']"
   :position="{bottom: 0}"
   contentTransitionName="trans-content-bottom"
   @afterEnterContent="handleAfterEntercontentOverlayModal"
   @closeOverlayModal="handleCloseOverlayModal"
  >
  <div class="pa-character-detail" v-if="hasCharacterData" ref="detailBox">
    <div class="icon-field" ref="iconField">
      <div class="pa-character-icon-wrapper">
        <CharacterIcon
         :character="character"
         :clickable="false"
        />
      </div>
    </div>

    <div class="user-guid" ref="headerField">
      <p v-if="character.number">塔経市帝管理番号: {{character.number.full}}</p>
      <p v-else>---</p>
    </div>

    <div class="user-detail-box" ref="contentField">
      <ul class="user-profile-set">
        <li>
          <p>登録呼称</p>
          <p>{{character.displayname | nameTruncate}}</p>
        </li>
        <li>
          <p>所属世／管轄</p>
          <p>{{belongsWorld}}</p>
        </li>
        <li v-if="character.type === 'user'">
          <p>滞在期間</p>
          <p>{{character.stamp_card.day_count}}日</p>
        </li>
      </ul>

      <template v-if="character.character_tag_list.length === 0">
        <div class="tag-list-none">
          <p>塔経市帝証票未取得</p>
          <p>たくさん利用して塔経市帝証票を取得しましょう。</p>
        </div>
      </template>
      <template v-else>
        <p class="tag-list-title">塔経市帝証票</p>
        <hr class="tag-list-separator" />
        <ul class="tag-list">
          <li v-for="tag in character.character_tag_list" :key="tag.id">{{tag.displayname}}</li>
        </ul>
      </template>
    </div>

    <div class="pa-button-wrap" ref="footerField">
      <div class="button-wrap">
        <button
        class="button add-pod"
        :disabled="isDisableAddButton"
        @click.prevent="handleClickAddButton"
        >{{addButtonText}}</button>
      </div>

      <div class="button-wrap-mini">
        <button
        class="button close-modal"
        :disabled="isDisableCloseButton"
        @click.prevent="handleClickCloseButton"
        >閉じる</button>
      </div>
    </div>
  </div>
  </PaOverlayModal>
</template>

<script>
import PaOverlayModal from '@/components/Parts/PAOverlayModal/PAOverlayModal.vue'
import CharacterIcon from '@/components/Parts/CharacterIcon/CharacterIcon.vue'

import CalcContentHeightMixin from '@/components/Parts/CharacterDetailModal/CalcContentHeightMixin.js'

import {GetCharacter} from '@/graphql/queries/Character.graphql'

import {GetMe}  from '@/graphql/queries/User.graphql'

export default {
  components : {
    PaOverlayModal,
    CharacterIcon
  },

  mixins : [
    CalcContentHeightMixin
  ],

  data(){
    return {
      addButtonText         : 'マイポットに投入する',
      isDisableAddButton    : false,

      isDisableCloseButton  : false,

      tagList               : [
      ],

      user                : {
        belongsWorld  : '異世界地球／秋葉原',
        dayCount      : '５２０１０３日',
        userType      : 'unknown',
      },

      isSameCharacter     : false,
    };
  },

  computed : {
    hasCharacterData(){
      if(typeof this.character === 'undefined') return false;
      if(this.character === null) return false;

      return true;
    },

    isModalOpen(){
      return this.$store.state.character.detailModal.isOpen;
    },

    characterId(){
      return this.$store.state.character.detailModal.characterId;
    },

    immmediateryOpenAddModal(){
      return this.$store.state.character.detailModal.immmediateryOpenAddModal;
    },

    belongsWorld(){
      return this.character.world[0].ward_name+'／'+this.character.world[0].location_name;
    }
  },

  apollo : {
    character : {
      query     : GetCharacter,
      variables(){
        return {
          id : this.characterId
        };
      },
      skip(){
        if(this.characterId === null){
          return true;
        }else{
          return false;
        }
      },
      error(err){
        const simpleErrorSet = this.getApolloSimpleErrorFromApolloError(err);
        
        this.apolloResultValidation(simpleErrorSet);
      }
    },

    me: {
      query: GetMe,
      error(err){
        const simpleErrorSet = this.getApolloSimpleErrorFromApolloError(err);
        
        this.apolloResultValidation(simpleErrorSet);
      }
    }
  },

  watch : {
    character : {
      handler(data){
        if(typeof data === 'undefined') return;

        // if(data.type === 'character'){
        //   this.isDisableAddButton = true;
        // }else{
        //   this.isDisableAddButton = false;
        // }

        // console.log(data);

        this.checkSameCharacter();
      },
      immediate: true
    },

    me : {
      handler(){
        this.checkSameCharacter();
      },
      immediate: true
    },

    // isSameCharacter : {
    //   handler(value){

    //     if(value === true){
    //       this.isDisableAddButton = true;
    //     }else{
    //       console.log(this.character);
    //     }

    //   },
    //   immediate: true
    // }
  },

  methods : {
    async handleAfterEntercontentOverlayModal(){
      this.setModalContentHeight();

      if(this.immmediateryOpenAddModal === true){
        this.isDisableAddButton = true;

        await this.UXWaiting(500);

        this.$store.dispatch({
          type      : 'connectionManageModal/updateConnectionManageModal',
          value     : true,
          character : this.character
        });

        setTimeout(() => {
          this.isDisableAddButton = false;
        }, 800);
      }else{
        this.isDisableAddButton = false;
        this.checkSameCharacter();
      }
    },

    handleClickCloseButton(){
      if(this.isDisableCloseButton) return;

      this.handleCloseOverlayModal();
    },

    handleClickAddButton(){
      if(this.isDisableAddButton) return;

      this.$store.dispatch({
        type      : 'connectionManageModal/updateConnectionManageModal',
        value     : true,
        character : this.character
      });
    },

    handleCloseOverlayModal(){
      this.$store.dispatch({
        type        : 'character/updateDetailModalIsOpen',
        value       : false,
        characterId : null
      });
    },

    checkSameCharacter(){
      if(typeof this.me === 'undefined') return;
      if(typeof this.character === 'undefined') return;

      if(this.me.primaryCharacter.id === this.character.id){
        this.isSameCharacter = true;
      }else{
        this.isSameCharacter = false;
      }

      if(this.isSameCharacter === true){
        this.isDisableAddButton = true;
      }else{
        if(this.character.type === 'character'){
          this.isDisableAddButton = true;
        }else{
          this.isDisableAddButton = false;
        }
      }
    }
  }
}
</script>

<style lang="scss">
@import "@/assets/scss/_variables.scss";
@import "~bulma/sass/utilities/_all";

.pa-layout.pa-overlay-modal.pa-character-detail-modal{
  .pa-contents{
    width:100vw;
  }

  .pa-character-detail{
    @include until($tablet) {
      width:100vw;
    }

    @include from($tablet) {
      max-width:600px;
      margin:0 auto;
      border-left:5px solid #CEB079;
      border-right:5px solid #CEB079;
      border-radius: 5px 5px 0 0;
    }
    
    min-height: 60px;
    border-top:5px solid #CEB079;
    background-color: #DDCEB3;

    .icon-field{
      position: absolute;
      top:-60px;
      left:calc(50% - (120px / 2));

      .pa-character-icon-wrapper{
        box-sizing: border-box;
        border:5px solid #CEB079;
        background-color: #DDCEB3;
        width:120px;
        height:120px;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;

        .pa-character-icon{
          box-sizing: border-box;
          background-color: #DDCEB3;
          width:110px;
          height:110px;
          line-height: 105px;
          font-size:4rem;

          @include until(375px) {
            width:90px;
            height:90px;
            line-height: 87px;
            font-size:3.5rem;
          }
        }
      }
    }

    .user-guid{
      margin-top:70px;
      color:#797979;
      background-color: #C8B593;
      text-align: center;
      font-size:1.2rem;
      line-height: 2.2rem;

      @include until(375px) {
        font-size:1rem;
        line-height: 2rem;
      }
    }

    .user-detail-box{
      width:95%;
      margin:0 auto;
      overflow-y: scroll;
    }

    .user-profile-set{
      padding-top:.6rem;
      li{
        background-color:#D7C8AD;
        border-bottom:3px solid #C4B191;
        border-radius:6px 6px 0 0;
        color:#333333;
        font-size: 1.2rem;
        line-height: 2.1rem;
        display: flex;
        flex-direction: row;
        margin-bottom:.6rem;

        @include until(375px) {
          font-size: 1rem;
          line-height: 1.9rem;
        }

        p{
          width:38%;
          padding-left:.4rem;
          color:#646464;
        }

        p:last-child{
          width:67%;
          padding-right:.4rem;
          color:#333333;
        }
      }

      margin-bottom:.6rem;
    }

    .tag-list-title{
      color:#9c8b6c;
      text-align: center;
      font-size:1.2rem;
      margin:-.3rem 0 .1rem;
    }

    .tag-list-separator{
      width:98%;
      margin:0 auto;
      background-color:#cebfa4;
      height:2px;
    }

    .tag-list{
      padding:.5rem 0;
      min-height:90px;

      li{
        display:inline-block;
        margin:.3rem .3rem;
        padding:.1rem 1rem;
        border-radius:20px;
        color:#797979;
        background-color:#C8B593;
        white-space: nowrap;
        cursor:pointer;
        user-select:none;
      }

      &-none{
        text-align: center;

        p{
          color:#BDAC8D;

          &:first-child{
            font-size:1.5rem;
            padding:2rem 0 0;
          
            @include until(375px) {
              font-size:1.2rem;
              padding:1rem 0 0;
            }
          }

          &:last-child{
            font-size:.9rem;
            padding:.2rem 0 3rem;

            @include until(375px) {
              padding:.1rem 0 2rem;
              font-size:.7rem;
            }
          }
        }
      }
    }

    .button-wrap{
      border-top:5px solid #C8B28B;

      &-mini{
        border-top:2px solid #C8B28B;
      }
    }

    .add-pod{
      display:block;
      width:100%;
      height:auto;
      border:0;
      border-radius:0;
      background-color:#884F2B;
      color:#D1D1D1;
      text-align:center;
      font-size:1.2rem;
      padding:.9rem 0 .8rem;
      line-height:1.2rem;

      @include until(375px) {
        font-size:1rem;
        padding:.8rem 0 .6rem;
        line-height:1rem;
      }
    }

    .close-modal{
      display:block;
      width:100%;
      height:auto;
      border:0;
      border-radius:0;
      background-color:#9c804b;
      color:#D1D1D1;
      text-align:center;
      font-size:.9rem;
      padding:.4rem 0 .3rem;
      line-height:1.1rem;

      @include until(375px) {
        padding:.5rem 0;
        font-size:1rem;
        line-height:1.2rem;
      }
    }
  }
}
</style>